import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { EventModel } from '@frontend/sports/betting-offer/feature/model';
import { Sitecore } from '@frontend/sports/common/client-config-data-access';

import { RedirectHelperService } from '../../navigation-core/redirect-helper.service';

@Component({
    selector: 'ms-bet-now-button',
    templateUrl: 'bet-now-button.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BetNowButtonComponent {
    @Input() event: EventModel;

    constructor(
        public sitecore: Sitecore,
        private redirectService: RedirectHelperService,
    ) {}

    click(): void {
        this.redirectService.goToEvent(this.event);
    }
}
